import React from 'react';
import './UIComponents.css';

/* ── Stat Card ── */
export const StatCard = ({ title, value, subtitle, icon, variant = 'orange', trend }) => (
  <div className={`stat-card stat-card--${variant}`}>
    <div className="stat-card-body">
      <div>
        <p className="stat-card-title">{title}</p>
        <h2 className="stat-card-value">{value}</h2>
        {subtitle && <p className="stat-card-sub">{subtitle}</p>}
        {trend && (
          <p className={`stat-card-trend ${trend.up ? 'trend-up' : 'trend-down'}`}>
            {trend.up ? '▲' : '▼'} {trend.text}
          </p>
        )}
      </div>
      <div className="stat-card-icon">{icon}</div>
    </div>
  </div>
);

/* ── Page Card ── */
export const PageCard = ({ title, subtitle, children, action, noPad }) => (
  <div className="page-card">
    {(title || action) && (
      <div className="page-card-header">
        <div>
          {title && <h3 className="page-card-title">{title}</h3>}
          {subtitle && <p className="page-card-sub">{subtitle}</p>}
        </div>
        {action && <div className="page-card-action">{action}</div>}
      </div>
    )}
    <div className={noPad ? '' : 'page-card-body'}>{children}</div>
  </div>
);

/* ── Primary Button ── */
export const BtnPrimary = ({ children, onClick, loading, disabled, type = 'button', fullWidth }) => (
  <button
    type={type}
    className={`btn-primary${fullWidth ? ' btn-full' : ''}`}
    onClick={onClick}
    disabled={disabled || loading}
  >
    {loading ? <span className="btn-spinner"/> : children}
  </button>
);

/* ── Secondary Button ── */
export const BtnSecondary = ({ children, onClick, type = 'button', fullWidth }) => (
  <button type={type} className={`btn-secondary${fullWidth ? ' btn-full' : ''}`} onClick={onClick}>
    {children}
  </button>
);

/* ── Form Field ── */
export const FormField = ({ label, error, children, required }) => (
  <div className="form-field">
    {label && (
      <label className="form-label">
        {label} {required && <span className="form-required">*</span>}
      </label>
    )}
    {children}
    {error && <p className="form-error">{error}</p>}
  </div>
);

/* ── Form Input ── */
export const FormInput = ({ icon, ...props }) => (
  <div className={`form-input-wrap${icon ? ' has-icon' : ''}`}>
    {icon && <span className="form-input-icon">{icon}</span>}
    <input className="form-input" {...props} />
  </div>
);

/* ── Form Select ── */
export const FormSelect = ({ children, ...props }) => (
  <select className="form-select" {...props}>{children}</select>
);

/* ── Status Badge ── */
export const Badge = ({ label, variant = 'info' }) => (
  <span className={`badge badge--${variant}`}>{label}</span>
);

/* ── Empty State ── */
export const EmptyState = ({ icon, title, description }) => (
  <div className="empty-state">
    <div className="empty-icon">{icon}</div>
    <h4 className="empty-title">{title}</h4>
    {description && <p className="empty-desc">{description}</p>}
  </div>
);

/* ── Loading Skeleton ── */
export const Skeleton = ({ height = 20, width = '100%', radius = 6 }) => (
  <div className="skeleton" style={{ height, width, borderRadius: radius }}/>
);

/* ── Alert Banner ── */
export const Alert = ({ type = 'info', children }) => (
  <div className={`alert alert--${type}`}>
    <span className="alert-icon">
      {type === 'success' && '✓'}
      {type === 'error'   && '✕'}
      {type === 'warning' && '⚠'}
      {type === 'info'    && 'ℹ'}
    </span>
    <span>{children}</span>
  </div>
);
